export const SignalRSymbol = Symbol('SignalRService');
